import { forgotPwdStrings } from '../../data/static/strings'
import { testProps } from '../../util/util'
import { mobileNumber } from '../../util/validations'
import { ForgotPasswordTextInput } from './../../comps/ForgotPasswordTextInput/index'

export const formData = (mobileNum: string): any => [
  {
    formItems: [
      {
        fieldName: 'mobileNumber',
        ComponentName: ForgotPasswordTextInput,
        label: 'Registered Phone Number (10 digits)',
        validationSchema: mobileNumber,
        maxLength: 10,
        value: mobileNum,
        inputMode: 'numeric',
        returnKeyType: 'done',
        placeholder: 'Registered Phone Number',
        ...testProps('forgot-mobile-input'),
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
export const pwdStrengthCbData = [
  {
    id: '1',
    value: forgotPwdStrings.eightCharacters,
  },
  {
    id: '2',
    value: forgotPwdStrings.oneLowerCaseLetter,
  },
  {
    id: '3',
    value: forgotPwdStrings.oneCapitalLetter,
  },
  {
    id: '4',
    value: forgotPwdStrings.oneSpecialCharacter,
  },
  {
    id: '5',
    value: forgotPwdStrings.oneDigit,
  },
]
